import { IScene } from "./models";

const scenes: Record<string, () => Promise<IScene>> = {
  BurgerJoint: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/BurgerJoint" */ "./burgerJoint/BurgerJoint"
      )
    ).default,
  GlennsHouseExterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/GlennsHouseExterior" */ "./glennsHouse/GlennsHouseExterior"
      )
    ).default,
  HospitalExterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/HospitalExterior" */ "./hospital/HospitalExterior"
      )
    ).default,
  Introduction: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/Introduction" */ "./sonnysHouse/Introduction"
      )
    ).default,
  HouseExterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/HouseExterior" */ "./sonnysHouse/HouseExterior"
      )
    ).default,
  LivingRoom: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/LivingRoom" */ "./sonnysHouse/LivingRoom"
      )
    ).default,
  Supermarket: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/Supermarket" */ "./supermarket/Supermarket"
      )
    ).default,
  SupermarketInterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/SupermarketInterior" */ "./supermarket/SupermarketInterior"
      )
    ).default,
  IntroHospital: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/HospitalIntro" */ "./hospital/HospitalIntro"
      )
    ).default,
  ShibariHQ: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/ShibariHQ" */ "./shibariBuilding/ShibariHQ"
      )
    ).default,
  DarethsHouseExterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsHouseExterior" */ "./darethsHouse/DarethsHouseExterior"
      )
    ).default,
  BankExterior: async (): Promise<IScene> =>
    (await import(/* webpackChunkName: "scenes/Bank" */ "./bank/Bank")).default,
  BankInterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/BankInterior" */ "./bank/BankInterior"
      )
    ).default,

  ATM: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/ATM" */ "./bank/ATM"
      )
    ).default,
  GlennsHouse: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/GlennsHouse" */ "./glennsHouse/GlennsHouse"
      )
    ).default,
  InsideBurgerJoint: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/InsideBurgerJoint" */ "./burgerJoint/InsideBurgerJoint"
      )
    ).default,
  DarethsFence: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsFence" */ "./darethsHouse/DarethsFence"
      )
    ).default,
  FightScene: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/FightScene" */ "./supermarket/FightScene"
      )
    ).default,
  DarethsYard: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsYard" */ "./darethsHouse/DarethsYard"
      )
    ).default,
  DarethsShed: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsShed" */ "./darethsHouse/DarethsShed"
      )
    ).default,
  DarethsFoyer: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsFoyer" */ "./darethsHouse/DarethsFoyer"
      )
    ).default,
  DarethsKitchen: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsKitchen" */ "./darethsHouse/DarethsKitchen"
      )
    ).default,
  GuardDog: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/GuardDog" */ "./darethsHouse/GuardDog"
      )
    ).default,
  FrontDoor: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/FrontDoor" */ "./darethsHouse/FrontDoor"
      )
    ).default,
  DarethsUpstairs: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsUpstairs" */ "./darethsHouse/DarethsUpstairs"
      )
    ).default,
  DarethsBathroom: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsBathroom" */ "./darethsHouse/DarethsBathroom"
      )
    ).default,
  DarethsBedroom: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/DarethsBedroom" */ "./darethsHouse/DarethsBedroom"
      )
    ).default,
  EmergencyRoom: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/EmergencyRoom" */ "./hospital/EmergencyRoom"
      )
    ).default,
  Elevator: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/Elevator" */ "./shibariBuilding/Elevator"
      )
    ).default,
  ShibariLobby: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/ShibariLobby" */ "./shibariBuilding/ShibariLobby"
      )
    ).default,
  HumanResources: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/HumanResources" */ "./shibariBuilding/HumanResources"
      )
    ).default,
  MiddleManagementFloor: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/MiddleManagementFloor" */ "./shibariBuilding/MiddleManagementFloor"
      )
    ).default,
  ComputerDatabase: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/ComputerDatabase" */ "./shibariBuilding/ComputerDatabase"
      )
    ).default,
  ConfrontDareth: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/ConfrontDareth" */ "./darethsHouse/ConfrontDareth"
      )
    ).default,
  Harbour: async (): Promise<IScene> =>
    (await import(/* webpackChunkName: "scenes/Harbour" */ "./harbour/Harbour"))
      .default,
  CruiseShipExterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/CruiseShipExterior" */ "./harbour/CruiseShipExterior"
      )
    ).default,
  CruiseShipInterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/CruiseShipInterior" */ "./harbour/CruiseShipInterior"
      )
    ).default,
  BuffetTable: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/BuffetTable" */ "./harbour/BuffetTable"
      )
    ).default,
  TitleScene: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/TitleScene" */ "./sonnysHouse/TitleScene"
      )
    ).default,
  TheEnd: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/TheEnd" */ "./sonnysHouse/TheEnd"
      )
    ).default,
  Knockout: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/Knockout" */ "./supermarket/Knockout"
      )
    ).default,
  OfficeInterior: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/OfficeInterior" */ "./shibariBuilding/OfficeInterior"
      )
    ).default,
  EssentialEmployees: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/EssentialEmployees" */ "./shibariBuilding/EssentialEmployees"
      )
    ).default,
  BelovedOldPub: async (): Promise<IScene> =>
    (
      await import(
        /* webpackChunkName: "scenes/BelovedOldPub" */ "./pub/BelovedOldPub"
      )
    ).default,
};

export { scenes };
